import React from 'react';
import { useCodeInput } from '../../use-code-input';
import * as RCI from './RCI';
export const CodeInput = ({ renderSegment, length = 6, fontFamily = "'SF Mono', SFMono-Regular, ui-monospace, Menlo, Monaco, 'Cascadia Mono', 'Segoe UI Mono', 'Roboto Mono', monospace", fontSize = '2rem', padding = '0.25rem', paddingY = padding, paddingX = padding, spacing = '0.5rem', characterWidth = '1ch', style, className, inputClassName, inputStyle, segmentWidth = `calc(${characterWidth} + ${paddingX} * 2)`, inputWidth = `calc(100% + ${segmentWidth} + ${spacing})`, inputRef, ...rest }) => {
    const selection = useCodeInput(inputRef);
    const rootStyle = {
        ...style,
        fontFamily,
        fontSize,
        letterSpacing: `calc(${paddingX} * 2 + ${spacing})`,
        lineHeight: `calc(${fontSize} + ${paddingY} * 2)`,
        position: 'relative',
        textIndent: paddingX,
        width: `calc(${segmentWidth} * ${length} + ${spacing} * ${length - 1})`,
        zIndex: 0,
    };
    const inputProps = {
        className: inputClassName,
        ref: inputRef,
        style: inputStyle,
    };
    return (<RCI.Context length={length} selection={selection}>
			<RCI.Root className={className} style={rootStyle}>
				<RCI.Absolute aria-hidden style={{ zIndex: -1 }}>
					
					<RCI.SegmentRenderer children={renderSegment}/>
				</RCI.Absolute>
				<RCI.InputScrollWrapper onDoubleClickCapture={() => {
            inputRef.current?.setSelectionRange(0, length);
        }} onMouseDownCapture={(event) => {
            if (event.button !== 0 || event.ctrlKey) {
                return;
            }
            if (event.shiftKey || event.metaKey) {
                return;
            }
            if (!(event.currentTarget instanceof HTMLElement)) {
                return;
            }
            if (!(inputRef.current instanceof HTMLInputElement)) {
                return;
            }
            event.stopPropagation();
            event.preventDefault();
            const { left, width } = event.currentTarget.getBoundingClientRect();
            const eventX = event.clientX - left;
            const index = Math.floor((eventX / width) * length);
            if (document.activeElement !== inputRef.current) {
                inputRef.current?.focus();
            }
            inputRef.current?.setSelectionRange(index, index + 1);
        }}>
					<RCI.Input width={inputWidth} {...rest} {...inputProps}/>
				</RCI.InputScrollWrapper>
			</RCI.Root>
		</RCI.Context>);
};
